import React from "react";

interface SparklineProps {
  data: number[];
  color?: string;
  height?: number;
  width?: number | string;
  fill?: boolean;
}

export const Sparkline: React.FC<SparklineProps> = ({
  data,
  color = "#4F46E5",
  height = 36,
  width = "100%",
  fill = true,
}) => {
  const gradId = React.useId();

  if (!data || data.length < 2) {
    return null;
  }

  const w = 100;
  const h = 36;
  const min = Math.min(...data);
  const max = Math.max(...data);
  const range = max - min || 1;
  const stepX = w / (data.length - 1);

  const points = data.map((v, i) => {
    const x = i * stepX;
    const y = h - ((v - min) / range) * h;

    return { x, y };
  });

  const path = points
    .map((p, i) => `${i === 0 ? "M" : "L"} ${p.x.toFixed(2)} ${p.y.toFixed(2)}`)
    .join(" ");

  const areaPath =
    `${path} L ${(points[points.length - 1].x).toFixed(2)} ${h} ` +
    `L ${points[0].x.toFixed(2)} ${h} Z`;

  return (
    <svg
      viewBox={`0 0 ${w} ${h}`}
      width={width}
      height={height}
      preserveAspectRatio="none"
      style={{ display: "block" }}
    >
      {fill && (
        <defs>
          <linearGradient id={gradId} x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor={color} stopOpacity={0.25} />
            <stop offset="100%" stopColor={color} stopOpacity={0} />
          </linearGradient>
        </defs>
      )}
      {fill && <path d={areaPath} fill={`url(#${gradId})`} />}
      <path d={path} fill="none" stroke={color} strokeWidth={1.5} strokeLinejoin="round" strokeLinecap="round" />
    </svg>
  );
};
